export default "__VITE_ASSET__BkOANXy3__"